import { defineStore } from 'pinia';
import getters from './getters';
import actions from './actions';
function initState() {
    return {
        houseDetailInfo: null,
        countryConfig: null //  set country ，nbr canada  special handling required
    };
}

export default (storeName) => defineStore(storeName, {
    state: initState,
    getters,
    actions
});
